import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';
import { UserPresenceMap, UserPresenceState, UserStatusType } from '../types';

export const useUserPresenceStoreSubscribe = createStoreWithSubscribe<UserPresenceState>(
  (set) => ({
    userPresenceData: {},
    loading: true,

    setUserPresenceData: (list) => {
      const map: UserPresenceMap = {};
      for (const user of list) {
        map[user.userId] = {
          userStatus: user.userStatus as UserStatusType,
          lastSeen: user.lastSeen,
        };
      }
      set({ userPresenceData: map });
    },

    updateUserPresence: (userId, userStatus, lastSeen) =>
      set((state) => ({
        userPresenceData: {
          ...state.userPresenceData,
          [userId]: { userStatus, lastSeen },
        },
      })),

    setLoading: (loading) => set({ loading }),
  }),
  {
    name: 'user-presence-store',
  }
);

// Internal shallow store for selective re-renders
export const useUserPresenceStore = createShallowStore(useUserPresenceStoreSubscribe);

// ✅ Custom hook for usage abstraction
export const useUserPresence = () => {
  const { userPresenceData, loading } = useUserPresenceStore('userPresenceData', 'loading');

  return {
    userPresenceData,
    loading,
  };
};
